// extracted by mini-css-extract-plugin
export default {"note":"aug9wS4AdQfY3_il","root":"gYCpUyQ6tY6IW1Tb","text":"mmxdSidI5UE4Q5Xz","title":"ZKXK8G_pJDE0kXON"};